// packages/app/src/scaffolder/PlatLeadGuard.tsx

import { useEffect, useState } from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { useNavigate } from 'react-router-dom';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { parseEksTeam } from '../utils/eksTeam';

/**
 * PlatLeadGuardComponent
 *
 * Safety net — redirects non-plat-leads away if they access
 * the create-team template via direct URL.
 * The card is already hidden by templateFilter in App.tsx.
 */
export const PlatLeadGuardComponent = ({
  onChange,
}: FieldExtensionComponentProps<string>) => {
  const identityApi = useApi(identityApiRef);
  const navigate    = useNavigate();
  const [checking, setChecking] = useState(true);
  const [denied, setDenied]     = useState(false);

  useEffect(() => {
    identityApi.getBackstageIdentity().then(identity => {
      const refs       = identity.ownershipEntityRefs ?? [];
      const isPlatLead = refs.some(ref => {
        const parsed = parseEksTeam(ref);
        return parsed !== null && parsed.isPlatform && parsed.role === 'lead';
      });

      if (!isPlatLead) {
        setDenied(true);
        setTimeout(() => navigate('/create'), 1500);
      } else {
        onChange('authorized');
      }
      setChecking(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checking) {
    return (
      <Box display="flex" alignItems="center" style={{ gap: 8 }}>
        <CircularProgress size={16} />
        <Typography variant="caption">Checking authorization…</Typography>
      </Box>
    );
  }

  if (denied) {
    return (
      <Box>
        <Typography variant="body2" color="error">
          You do not have permission to create teams. Redirecting…
        </Typography>
      </Box>
    );
  }

  return null;
};
